<template>

  <div class="px-2" style="{backgruond-color:white}">
    <HeaderBar />
    <!-- search input -->
    <v-offline online-class="online" offline-class="offline" @detected-condition="onConnectionChange">
      <template v-if="online">
        <div class="flex w-full h-full justify-center items-center text-6xl">

        </div>
      </template>
      <template v-if="!online">
        <div class="flex w-full h-full justify-center items-center text-6xl">
          Sin Conexión
        </div>
      </template>
    </v-offline>
    <div class="d-flex justify-content-center mt-1 headTitle mb-2">Desparacitaciones</div>
    <div class="d-flex justify-content-center mt-1 headTitle mb-2">{{ fincaName }}</div>
    <!-- table -->
    <vue-good-table :columns="columns" :rows="rows" :rtl="direction" styleClass="vgt-table bordered" :search-options="{
      enabled: true,
      externalQuery: searchTerm
    }" :pagination-options="{
      enabled: true,
      perPage: pageLength,
      mode: 'records',
      nextLabel: ' Siguiente > ',
      prevLabel: ' < Anterior ',
      perPageDropdown: [10, 20, 50, 100],
      dropdownAllowAll: false,
      rowsPerPageLabel: 'Desparasitaciones por página',
      ofLabel: 'de',
      position: 'bottom',
      pageLabel: 'página',
    }" :sort-options="{
        enabled: true,
      }">

      <!-- Custom slot for the Edit button in the actions column -->
      <template slot="table-row" slot-scope="props">
        <!-- Check if the column is 'actions' to display the Edit button -->
        <span v-if="props.column.field === 'actions'">
          <a class="btn btn-primary btn-sm" @click="editBtn(props.row.id)" v-if="!isAdmin()"><span class="fa fa-pencil"></span></a>
          <a class="btn btn-danger btn-sm" @click="delHealthRecord(props.row.id)" v-if="!isAdmin()"><span class="fa fa-x"></span></a>
        </span>
        <!-- Display default value for other columns -->
        <span v-else>{{ props.row[props.column.field] }}</span>
      </template>



    </vue-good-table>

    <div class="d-flex justify-content-center  mt-2 mb-1"><b-button @click="exportCSV" class="bg-primary w-50"> Exportar
        CSV</b-button></div>

    <AddButton preTitle="Agregar Desparasitaciones" goTo='basic-loaddatadeworming' v-if="!isAdmin()"/>
    <ControlMenu />
  </div>
</template>

<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import AddButton from '@/components/AddButton.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAvatar, BBadge, BPagination, BFormGroup, BFormSelect, BFormFile, BFormCheckbox, BDropdown, BDropdownItem, BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormInput, BInputGroup, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import PlusButton2 from '@/components/PlusButton2.vue'
import store from '@/store/index'
import { VOffline } from 'v-offline';
import axios from "axios";
export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BInputGroup,
    BCardBody,
    BCard,
    VueGoodTable,
    vSelect,
    PlusButton2,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormFile,
    BDropdown,
    BDropdownItem,
    ControlMenu,
    HeaderBar,
    AddButton,
    VOffline
  },
  data() {
    return {
      currentLevelAccess: localStorage.getItem("currentLevelAccess"),
      fincaName: localStorage.getItem('currentFarmName'),
      online: false,
      fileU: null,
      imgWidth: null,
      currAmimal: 0,
      pageLength: 10,
      dir: false,
      status1: null,
      status2: null,
      modalShow: false,
      modalCase: 0,
      editShow: false,
      modalTrashShow: false,
      columns: [
        {
          label: 'ID',
          field: 'id',
          hidden: true,
        },
        {
          label: 'Fecha',
          field: 'date',
          sortable: true,
        },
        {
          label: 'Numero',
          field: 'code',
          sortable: true,
        },
        {
          label: 'Animal',
          field: 'animal',
          sortable: true,
        },
        {
          label: 'Desparasitante',
          field: 'product',
          sortable: true,
        },
        {
          label: 'Tipo',
          field: 'type',
          sortable: true,
        },
        {
          label: 'Ingrediente',
          field: 'active',
          sortable: true,
        },
        {
          label: 'Dias',
          field: 'days',
          sortable: true,
        },
        {
          label: 'Acciones',
          field: 'actions',
          sortable: false
        }
      ],
      rows: [],
      rowsExport: [],
      animalData: [],
      animal: {
        name: "",
        number: "",
        sirigapp: "",
        weight: 0,
        age: 0,
        sex: false,
        mother: "",
        dad: "",
        image_url: "",
        image1: "",
        image2: "",
        image3: "",
        birthdate: "",
        buy_date: null,
        farm_id: localStorage.getItem('currentFarm'),
        state: 1,
        price: 0,
        batch_id: 'Otro'
      },
      weighinsData: {
        labels: [],
        datasets: [
          {
            label: 'Evolución de peso',
            backgroundColor: '#5E8F23',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        backgroundColor: false,
        hover: {
          mode: 'label',
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 20
          },
        },

        legend: {
          position: 'top',
          align: 'start',
          labels: {
            usePointStyle: true,
            padding: 25,
            boxWidth: 9,
          },
        },
      },
      weighins: {
        observations: '',
        animal_id: this.currAmimal,
        weight: 0,
        date: ''
      },
      searchTerm: '',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      vaccionations: 0,
      dewormings: 0,
      treathments: 0,
      alerts: 0,
      childs: 0,
      reproductive: 0,
      parts: 0,
      abortions: 0,
      palpations: 0,
      andrology: 0,
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  methods: {
    isAdmin() {
            return this.currentLevelAccess === "Visualizador";
    },
    editBtn(idItem) {
      let id = idItem;
      this.$router.push('/advancehome/datalog/healthweight/health/Dewormingedit/'+ id)
    },
    delHealthRecord(idItem) {
      const token = localStorage.getItem("accessToken");
      const config = { headers: { "X-Authorization": `Bearer ${token}` } };
      let self = this;

      this.$swal({
        title: 'Eliminar registro',
        text: '¿Seguro que desea eliminar el registro?',
        type: 'warning',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Si',
        showDenyButton: true,
        denyButtonText: 'No',
        confirmButtonColor: '#5E8F23',
        showCloseButton: false,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.get(this.$apiUrl + 'delete/health_records/' + idItem, config)
            .then(function () {
              self.$swal({
                title: 'Eliminado',
                text: 'El registro ha sido eliminado exitosamente',
                icon: 'success',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#5E8F23'
              });
              self.$router.go(0);
            })
        }

      });
    },
    async fetchhealth_records(config) {
      console.log("funciona :3 1");
      if (this.online) {
        let farmId = localStorage.getItem('currentFarm');
        console.log('id', farmId)
        //let farmId = 85;
        fetch(this.$apiUrl + "/list/DemormerbyAnimals?farm_id=" + farmId+'&recperpage=all', config)
          .then(response => response.json())
          .then(result => {
            console.log(result.DemormerbyAnimals);
            this.rows = result.DemormerbyAnimals.map(item => { return {id:item.id,code:item.number,animal:item.name, type: item.dewormer,active:item.dewormer_ingredient,product:item.product_name, date: item.date, days:item.days } });
            localStorage.setItem('healthRecordsTemp', JSON.stringify(this.rows))
            console.log(this.rows);
          })
      } else {
        let localHealth_records = JSON.parse(localStorage.getItem('healthRecordsTemp'));
        if (localHealth_records.length > 0) {
          this.rows = localHealth_records.map(item => {return {id:item.id,code:item.number,animal:item.name, type: item.dewormer,active:item.dewormer_ingredient,product:item.product_name, date: item.date, days:item.days } });
        }
      }
    },

    navigateTo(val) {
      this.$router.push(val);
    },
    onConnectionChange(val) {
      this.online = val;
      console.log(val);
    },
    exportCSV() {
      const myLogs = this.arrayToCsv(this.rows);
      this.downloadBlob(myLogs, './animales_export.csv', 'text/csv;charset=utf-8,%EF%BB%BF;');
      console.log("Logs has been saved");
    },
    arrayToCsv(data) {
        // Obtener el orden y los nombres de las columnas
    const orderedColumns = this.columns.filter(col => !col.hidden && col.field !== 'actions'); // Filtrar columnas ocultas
    const headers = orderedColumns.map(col => col.label); // Obtener los nombres de las columnas

    // Crear el contenido del CSV
    const csvContent = [
        headers.join(','), // Encabezados
        ...data.map(row => {
            return orderedColumns.map(col => row[col.field]).join(','); // Filtrar los valores según el orden de las columnas
        })
    ].join('\n');

    return csvContent;
    },
    downloadBlob(content, filename, contentType) {
      // Create a blob
      var blob = new Blob([content], { type: contentType });
      var url = URL.createObjectURL(blob);

      // Create a link to download it
      var pom = document.createElement('a');
      pom.href = url;
      pom.setAttribute('download', filename);
      pom.click();
    },
  },

  watch: {
    'fileU': function (value) {
      this.imgWidth = 200;
      this.featured = URL.createObjectURL(this.fileU);
      console.log(value);
    },
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = { headers: { "X-Authorization": `Bearer ${token}` } };
    this.online = navigator.onLine;
    this.fetchhealth_records(config);
  },

}



</script>
<style lang="scss">
body {
  background-color: white !important;
}

table {
  width: 100% !important;

}

.vgt-responsive{
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; 
}
.subTitle {
  font-weight: 600;
  font-size: 23px;

}

.linkTitle {

  font-weight: 500;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #5E8F23;

}

.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}

thead {
  background-color: #5E8F23;
  text-align: center;
  color: #ffffff;
}

thead>tr {
  padding: 5px;
}

.editAnimal {
  font-weight: 500;
  font-size: 18px;
}


.editModal {
  font-weight: 500;
  font-size: 18px;
}

span.text-center {
  display: flex;
  justify-content: center;
  text-align: center;
}

.footer__navigation__page-btn {
  background-color: #5e8f23;
  /* color de fondo */
  color: white;
  /* color del texto */
  border-radius: 4px;
  padding: 5px 10px;
  text-align: center;
}

.footer__row-count {
  margin-top: 10px;
}

.footer__navigation,
.vgt-pull-right {
  text-align: center !important;
  width: 100%;
  display: grid;
  margin-top: 10px;
}
</style>